import $api from "../Api";
import ResponseChecker from "../Middlewares/ResponseChecker";
import { defaultMessages } from "../enums/responseMessages.js";
import Endpoints from "../Endpoints";

const check = (response) => ResponseChecker(defaultMessages, response);
export const GetAll = async (option) => check(await $api.get(Endpoints.CreditCard.GetAll(option)));
export const Create = async (form) => check(await $api.post(Endpoints.CreditCard.Create(), form));
export const Update = async (form, option) => check(await $api.put(Endpoints.CreditCard.Update(option), form));
export const Delete = async (option) =>
  check(await $api.delete(Endpoints.CreditCard.Delete(option)));
export const UpdateActive = async (form, option) =>
  check(await $api.put(Endpoints.CreditCard.UpdateActive(option), form));
export default { GetAll, Create, Update, Delete, UpdateActive };
